// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3JNCH","productName":"Table_productName__1Xhk2"};